import type { FC, ReactNode } from 'react'

import { Play } from 'lucide-react'

const COLUMNS = [
    {
        heading: 'Browse',
        links: [
            { label: 'Library', href: '#library' },
            { label: 'How it works', href: '#how' },
            { label: 'Stories', href: '#stories' }
        ]
    },
    {
        heading: 'Shelves',
        links: [
            { label: 'Ship With AI', href: '#library' },
            { label: 'Founder OS', href: '#library' },
            { label: 'Solo to SaaS', href: '#library' }
        ]
    },
    {
        heading: 'Company',
        links: [
            { label: 'Early access', href: '#waitlist' },
            { label: 'Contact', href: '#waitlist' },
            { label: 'Privacy', href: '#waitlist' }
        ]
    }
]

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='border-t border-black/8 bg-[#f5f5f7] px-4 py-16 md:px-6'>
            <div className='mx-auto max-w-6xl'>
                <div className='grid gap-10 md:grid-cols-[1.5fr_1fr_1fr_1fr]'>
                    <div>
                        <a href='#top' className='flex items-center gap-2'>
                            <span className='flex h-8 w-8 items-center justify-center rounded-lg bg-[#1a1a1a] text-white'>
                                <Play className='size-4 fill-white' />
                            </span>
                            <span className='text-lg font-semibold tracking-tight text-[#1a1a1a]'>
                                Stream Showcase
                            </span>
                        </a>
                        <p className='mt-4 max-w-xs text-sm leading-relaxed text-[#777]'>
                            A streaming-style library of curated playlists that help founders,
                            indie hackers, and makers level up.
                        </p>
                    </div>

                    {COLUMNS.map((col) => (
                        <div key={col.heading}>
                            <h3 className='text-xs font-semibold uppercase tracking-[0.14em] text-[#999]'>
                                {col.heading}
                            </h3>
                            <ul className='mt-4 space-y-3'>
                                {col.links.map((link) => (
                                    <li key={link.label}>
                                        <a
                                            href={link.href}
                                            className='text-sm text-[#555] transition-colors hover:text-[#1a1a1a]'
                                        >
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className='mt-14 flex flex-col items-center justify-between gap-4 border-t border-black/8 pt-8 sm:flex-row'>
                    <p className='text-xs text-[#999]'>
                        &copy; {new Date().getFullYear()} Stream Showcase. Built for people who make things.
                    </p>
                    <p className='text-xs text-[#999]'>Queue up. Level up.</p>
                </div>
            </div>
        </footer>
    )
}
